import React, { useEffect } from 'react';
import { Box, Typography, Button, Paper, useMediaQuery, useTheme } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppBooking = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleWhatsAppClick = () => {
    const phoneNumber = '+15550228837'; // Format: country code + number without + or spaces
    const message = encodeURIComponent('Hola! Quisiera hacer una reserva en el restaurante.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  // Auto-open WhatsApp on mobile when component mounts
  // useEffect(() => {
  //   if (isMobile) {
  //     handleWhatsAppClick();
  //   }
  // }, [isMobile]);

  // If mobile, just show a simple message
  if (isMobile) {
    return (
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2,
        }}
      >
        <WhatsAppIcon sx={{ fontSize: 60, color: '#25D366' }} />
        <Typography variant="h6" sx={{ fontWeight: 500 }}>
          Abriendo WhatsApp...
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Si no se abrió automáticamente, haga clic abajo
        </Typography>
        <Button
          variant="contained"
          color="success"
          size="large"
          startIcon={<WhatsAppIcon />}
          onClick={handleWhatsAppClick}
          fullWidth
          sx={{
            py: 1.5,
            textTransform: 'none',
            fontSize: '1rem',
            borderRadius: 2,
          }}
        >
          Abrir WhatsApp
        </Button>
      </Paper>
    );
  }

  // Desktop view with full description
  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        borderRadius: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <WhatsAppIcon sx={{ fontSize: 60, color: '#25D366', mb: 2 }} />
      <Typography variant="h5" sx={{ fontWeight: 500, mb: 2 }}>
        WhatsApp
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, flexGrow: 1 }}>
        Como si estuvieras hablando con una persona.
      </Typography>
      <Button
        variant="contained"
        color="success"
        size="large"
        startIcon={<WhatsAppIcon />}
        onClick={handleWhatsAppClick}
        fullWidth
        sx={{
          py: 1.5,
          textTransform: 'none',
          fontSize: '1rem',
          borderRadius: 2,
        }}
      >
        Abrir WhatsApp
      </Button>
    </Paper>
  );
};

export default WhatsAppBooking;
